var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLLocalDate, GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { DailyDepartmentNotificationNode } from "../resources/DailyDepartmentNotification.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListDailyDepartmentNotificationsResponse = class ListDailyDepartmentNotificationsResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [DailyDepartmentNotificationNode]),
    __metadata("design:type", Array)
], ListDailyDepartmentNotificationsResponse.prototype, "data", void 0);
ListDailyDepartmentNotificationsResponse = __decorate([
    ObjectType("ListDailyDepartmentNotificationsResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListDailyDepartmentNotificationsResponse);
export { ListDailyDepartmentNotificationsResponse };
let DailyDepartmentNotificationInput = class DailyDepartmentNotificationInput {
    division;
    department;
    effectiveDate;
    processDate;
    pledgedDate;
    transactionDate;
    transactionType;
    donor1Amount;
    donor2Amount;
    combinedAmount;
    pledgedAmount;
    accountNumber;
    accountName;
    holdingDestination;
    comment;
    secShares;
    secType;
    gikType;
    gikDescription;
    onlineGift;
    solicitationCode;
    solicitation;
    behalfHonorMemorial;
    matchingGift;
    batchId;
    ukFirstGift;
    divFirstGift;
    idSorter;
    combinedDonorName;
    combinedDonorSalutation;
    combinedDonorSort;
    donor1Id;
    donor1GiftKey;
    donor1Name;
    donor1Deceased;
    donor1Constituency;
    donor1TitleBar;
    donor1Pm;
    donor1Degrees;
    donor2Id;
    donor2GiftKey;
    donor2Name;
    donor2Deceased;
    donor2Constituency;
    donor2TitleBar;
    donor2Pm;
    donor2Degrees;
    donor1Relation;
    donor2Relation;
    transmittalSn;
    sapDocNum;
    sapDocDate;
    jvDocNum;
    jvDocDate;
    advFeeCcPhil;
    advFeeAmtPhil;
    advFeeCcUnit;
    advFeeAmtUnit;
    advFeeStatus;
    hcUnit;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "division", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "department", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "effectiveDate", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "processDate", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "pledgedDate", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "transactionDate", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "transactionType", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Amount", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Amount", void 0);
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationInput.prototype, "combinedAmount", void 0);
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationInput.prototype, "pledgedAmount", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "accountNumber", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "accountName", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "holdingDestination", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "comment", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "secShares", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "secType", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "gikType", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "gikDescription", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationInput.prototype, "onlineGift", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "solicitationCode", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "solicitation", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "behalfHonorMemorial", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "matchingGift", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "batchId", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationInput.prototype, "ukFirstGift", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationInput.prototype, "divFirstGift", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "idSorter", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "combinedDonorName", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationInput.prototype, "combinedDonorSalutation", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "combinedDonorSort", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Id", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1GiftKey", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Name", void 0);
__decorate([
    Field(() => Boolean, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Deceased", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Constituency", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1TitleBar", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Pm", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Degrees", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Id", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2GiftKey", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Name", void 0);
__decorate([
    Field(() => Boolean, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Deceased", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Constituency", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2TitleBar", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Pm", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Degrees", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor1Relation", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "donor2Relation", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "transmittalSn", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "sapDocNum", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "sapDocDate", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "jvDocNum", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "jvDocDate", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "advFeeCcPhil", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "advFeeAmtPhil", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "advFeeCcUnit", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "advFeeAmtUnit", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "advFeeStatus", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationInput.prototype, "hcUnit", void 0);
DailyDepartmentNotificationInput = __decorate([
    InputType()
], DailyDepartmentNotificationInput);
export { DailyDepartmentNotificationInput };
let ListDailyDepartmentNotificationsArgs = class ListDailyDepartmentNotificationsArgs extends FilteredListQueryArgs("DailyDepartmentNotificationResolver", [
    "Amount",
    "Donor",
    "Comment",
    "SolicitationCodeName",
    "SolicitationCodeNumber",
    "SolicitationCodePrefix",
    "BatchType",
    "createdAt",
    "combinedDonorName",
    "combinedAmount",
    "comment",
    "solicitationCode",
    "batch",
]) {
};
ListDailyDepartmentNotificationsArgs = __decorate([
    ArgsType()
], ListDailyDepartmentNotificationsArgs);
export { ListDailyDepartmentNotificationsArgs };
//# sourceMappingURL=DailyDepartmentNotificationParams.js.map